import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const YearOfManufacture = (props) => {
  return (
    <FormGroup controlId="yearOfManufacture">
      <Col componentClass={ControlLabel} sm={5}>
        Year Of Manufacture *
      </Col>
      <Col sm={7}>
        <FormControl type="number"
          value={props.yearOfManufacture}
          onChange={props.handleChangeYearOfManufacture}
          autoComplete="off"
          required
        />
      </Col>

    </FormGroup>
  )
}

YearOfManufacture.propTypes = {
  yearOfManufacture: PropTypes.string,
  handleChangeYearOfManufacture: PropTypes.func
};

export default YearOfManufacture;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/yearOfManufacture/YearOfManufacture.js